/* ============================================================
   THE FOLKS — theme behaviour (Shopify)
   Scroll reveals, header, marquees, counters, parallax, toast.
   Localisation is handled by Shopify locale files, not JS.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------------------------------------------------------
     2. HEADER — scrolled state + hide on scroll down
     --------------------------------------------------------- */
  var hdr = $('.hdr');
  var lastY = window.scrollY;
  var prog = $('.prog');

  function onScroll() {
    var y = window.scrollY;
    if (hdr) {
      hdr.dataset.scrolled = y > 24 ? 'true' : 'false';
      var open = document.body.dataset.menu === 'open';
      hdr.dataset.hidden = !open && y > 420 && y > lastY + 4 ? 'true' : 'false';
    }
    if (prog) {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      prog.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, y / h) : 0) + ')';
    }
    lastY = y;
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { onScroll(); ticking = false; });
  }, { passive: true });
  onScroll();

  /* ---------------------------------------------------------
     3. MOBILE MENU
     --------------------------------------------------------- */
  var burger = $('.burger');
  if (burger) {
    burger.addEventListener('click', function () {
      var open = document.body.dataset.menu === 'open';
      document.body.dataset.menu = open ? 'closed' : 'open';
      burger.setAttribute('aria-expanded', String(!open));
    });
  }
  $$('.mmenu a').forEach(function (a) {
    a.addEventListener('click', function () {
      document.body.dataset.menu = 'closed';
      if (burger) burger.setAttribute('aria-expanded', 'false');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.dataset.menu === 'open') {
      document.body.dataset.menu = 'closed';
      if (burger) burger.setAttribute('aria-expanded', 'false');
    }
  });

  /* ---------------------------------------------------------
     4. SCROLL REVEALS
     --------------------------------------------------------- */
  function splitWords(el) {
    if (el.dataset.split === 'done') return;
    var html = el.innerHTML;
    // split only top-level text, keep inline tags intact per word chunk
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    // chunks: [{html, sep}] — sep = whitespace that preceded the chunk
    var chunks = [];
    function push(html, sep) {
      // glue a chunk onto the previous one when no whitespace separates them
      // (keeps "<i>rooms</i>," together instead of orphaning the comma)
      if (sep === '' && chunks.length) { chunks[chunks.length - 1].html += html; return; }
      chunks.push({ html: html, sep: sep });
    }
    var pend = '';
    var first = true;
    Array.prototype.forEach.call(tmp.childNodes, function (n) {
      if (n.nodeType === 3) {
        n.textContent.split(/(\s+)/).forEach(function (w) {
          if (w === '') return;
          if (!w.trim()) { pend += w; return; }
          push(w, first ? ' ' : pend); pend = ''; first = false;
        });
      } else if (n.nodeType === 1) {
        push(n.outerHTML, first ? ' ' : pend); pend = ''; first = false;
      }
    });
    var out = '';
    chunks.forEach(function (c, i) {
      out += (i ? c.sep || ' ' : '') + '<span class="w"><i style="--i:' + i + '">' + c.html + '</i></span>';
    });
    el.innerHTML = out;
    el.dataset.split = 'done';
  }

  /* NOTE: elements hidden with clip-path report intersectionRatio 0 in Chromium,
     so .rv-clip is driven by a scroll/rect check instead of IntersectionObserver. */
  var clipEls = [];
  var clipTick = false;

  function checkClips() {
    clipTick = false;
    var h = window.innerHeight;
    clipEls = clipEls.filter(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < h * 0.94 && r.bottom > 0) { el.classList.add('in'); return false; }
      return true;
    });
  }
  function queueClips() {
    if (clipTick) return;
    clipTick = true;
    requestAnimationFrame(checkClips);
  }
  window.addEventListener('scroll', queueClips, { passive: true });
  window.addEventListener('resize', queueClips);

  function initReveals() {
    if (reduce) { $$('.rv,.rv-up,.rv-clip,.rw').forEach(function (el) { el.classList.add('in'); }); return; }
    $$('.rw').forEach(splitWords);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    $$('.rv,.rv-up,.rw').forEach(function (el) { io.observe(el); });

    $$('.rv-clip').forEach(function (el) {
      if (el.classList.contains('in') || clipEls.indexOf(el) >= 0) return;
      clipEls.push(el);
    });
    checkClips();
  }

  /* ---------------------------------------------------------
     5. COUNTERS
     --------------------------------------------------------- */
  function initCounters() {
    var els = $$('[data-count]');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        io.unobserve(el);
        var target = parseFloat(el.dataset.count);
        var dec = parseInt(el.dataset.dec || '0', 10);
        var sep = el.dataset.sep || '';
        var suffix = el.dataset.suffix || '';
        if (reduce) { el.textContent = fmt(target, dec, sep) + suffix; return; }
        var dur = 1500, t0 = performance.now();
        function step(t) {
          var p = Math.min(1, (t - t0) / dur);
          var e = 1 - Math.pow(1 - p, 3);
          el.textContent = fmt(target * e, dec, sep) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }
  function fmt(n, dec, sep) {
    var s = dec ? n.toFixed(dec).replace('.', ',') : String(Math.round(n));
    if (sep) {
      var parts = s.split(',');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      s = parts.join(',');
    }
    return s;
  }

  /* ---------------------------------------------------------
     6. MARQUEE — duplicate track for a seamless loop
     --------------------------------------------------------- */
  function initMarquees() {
    $$('.marq').forEach(function (m) {
      var t = m.querySelector('.marq__t');
      if (!t || m.dataset.dup === 'done') return;
      var c = t.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      m.appendChild(c);
      m.dataset.dup = 'done';
    });
  }

  /* ---------------------------------------------------------
     7. PARALLAX (subtle, transform-only)
     --------------------------------------------------------- */
  function initParallax() {
    if (reduce) return;
    var els = $$('[data-par]');
    if (!els.length) return;
    function frame() {
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var vh = window.innerHeight;
        if (r.bottom < -200 || r.top > vh + 200) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh; // -1..1
        el.style.transform = 'translate3d(0,' + (p * parseFloat(el.dataset.par)).toFixed(2) + 'px,0)';
      });
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* ---------------------------------------------------------
     8. TOAST + cart-lite counter
     --------------------------------------------------------- */
  var toastEl;
  window.folksToast = function (msg, bad) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    var icon = bad
      ? '<path d="M8 4.4v4.2M8 11.4h.01" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><circle cx="8" cy="8" r="6.2" stroke="currentColor" stroke-width="1.3"/>'
      : '<path d="M3 8.5l3.2 3.2L13 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>';
    toastEl.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' + icon + '</svg><span></span>';
    toastEl.querySelector('span').textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('show'); }, 2600);
  };

  /* ---------------------------------------------------------
     9. YEAR
     --------------------------------------------------------- */
  function initYear() {
    $$('[data-year]').forEach(function (el) { el.textContent = new Date().getFullYear(); });
  }

  /* ---------------------------------------------------------
     10. OPEN / CLOSED badge for locations
     --------------------------------------------------------- */
  window.folksOpenNow = function (loc) {
    var d = new Date();
    var day = d.getDay(); // 0 Sun
    var weekend = day === 0 || day === 5 || day === 6;
    var range = weekend ? loc.hours.weekend : loc.hours.weekday;
    var m = range.match(/(\d{1,2}):(\d{2})\s*[–-]\s*(\d{1,2}):(\d{2})/);
    if (!m) return null;
    var now = d.getHours() * 60 + d.getMinutes();
    var a = +m[1] * 60 + +m[2], b = +m[3] * 60 + +m[4];
    return { open: now >= a && now < b, range: range };
  };

  /* ---------------------------------------------------------
     11. SHOPIFY CART COUNT
     --------------------------------------------------------- */
  function renderCart(count) {
    if (typeof count !== 'number') {
      var b = document.body.getAttribute('data-cart-count');
      count = parseInt(b || '0', 10) || 0;
    }
    document.body.setAttribute('data-cart-count', String(count));
    $$('[data-cart-count]').forEach(function (el) {
      if (el === document.body) return;
      el.textContent = count;
      el.hidden = count === 0;
    });
  }
  window.folksSetCartCount = renderCart;

  function refreshCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c.item_count); })
      .catch(function () {});
  }
  document.addEventListener('folks:cart-updated', function () { refreshCartCount(); });
  document.addEventListener('cart:refresh', function () { refreshCartCount(); });
  if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { refreshCartCount(); });
  }

  /* ---------------------------------------------------------
     BOOT
     --------------------------------------------------------- */
  function boot() {
    initMarquees();
    /* the intro curtain (folks-wow.js) holds the reveals back until it lifts */
    if (!document.documentElement.classList.contains('ldr-on')) initReveals();
    initCounters();
    initParallax();
    initYear();
    renderCart();
    document.body.classList.add('ready');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.folksInitReveals = initReveals;
  window.folksRefresh = function () {
    initMarquees();
    initReveals();
    initCounters();
  };
})();
